module.exports = __webpack_public_path__ + "img/w6-b2.c6e3b77f.jpg";